import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { pageUrl } from '@/constants/url'

const TeamsPage = lazy(() => import('./pages/users'))
const RolePage = lazy(() => import('./pages/roles'))
const SchedulePage = lazy(() => import('./pages/schedule'))
const AttendancePage = lazy(() => import('./pages/attendance'))

export const teamRoutes = () => {
  return (
    <>
      <Route path={pageUrl.teams} element={<TeamsPage />} />
      <Route path={pageUrl.role} element={<RolePage />} />
      <Route path={pageUrl.teamsSchedule} element={<SchedulePage />} />
      <Route path={pageUrl.teamsAttendance} element={<AttendancePage />} />
    </>
  )
}
